module.exports = __webpack_public_path__ + "static/media/Drug AddictionActive.28e4d89e.svg";